<template>
  <div class="column">
    <div class="column__image-container">
      <img class="column__image" v-if="image" :src="image.url" />
    </div>
    <h3 class="column__title">{{title}}</h3>
    <rich-text :textData="copy" />
  </div>
</template>

<script>
import RichText from './RichText.vue';

export default {
  props: ['image', 'title', 'copy'],
  components: { RichText },
};
</script>

<style scoped>
.column {
  padding: 36px;
  text-align: center;
  border-radius: 3px;
}

.column__image-container {
  height: 75px;
  margin: 0 0 24px 0;
}

.column__image {
  max-width: 100%;
  max-height: 100%;
}

.column__title {
  width: 100%;
  margin: 0 0 24px 0;
  padding: 0 15%;
  line-height: 1.5;
}

.column__text {
  margin: 0;
  line-height: 1.5;
}
</style>
